import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import { AppUiActions } from '../../../store/actions';
import * as fromRoot from '../../../store/reducers';
import * as Enum from '../../../dtos/enums';
import { TestTakerService } from '../../../services/test-taker.service';
import * as ErrorMessages from '../../../errors/constants';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'lock-screen',
    template: require('./lock-screen.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LockScreenComponent implements OnInit, OnDestroy {
    isLockScreenVisibleSubscription: Subscription;
    testTakerInfoSubscription: Subscription;
    isLockScreenVisible: boolean = false;
    testTakerPhotoUrl: string;
    errorMsg: string;

    constructor(
        private store: Store<fromRoot.State>,
        private testTakerService: TestTakerService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit() {

        this.isLockScreenVisibleSubscription = this.store.select(fromRoot.getIsLockScreenVisible).subscribe(isLockScreenVisible => {
            this.isLockScreenVisible = isLockScreenVisible;
            this.changeDetectorRef.markForCheck();
        });

        this.testTakerInfoSubscription = this.store.select(fromRoot.getTestTakerInfo).subscribe(testTakerInfo => {
            if (testTakerInfo) {
                this.testTakerPhotoUrl = this.testTakerService.getTestTakerPhotoUrl(testTakerInfo.BrandName, testTakerInfo.TestSessionSiteCode, testTakerInfo.TestTakerId);
                this.changeDetectorRef.markForCheck();
            }
        });
    }

    ngOnDestroy() {
        this.isLockScreenVisibleSubscription.unsubscribe();
        this.testTakerInfoSubscription.unsubscribe();
    }

    checkExitCode(exitCode: string) {
        this.errorMsg = "";

        if (this.testTakerService.testTakerInfo.CtcCode == exitCode) {
            this.store.dispatch(new AppUiActions.HideLockScreen());
            this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.ScreenLockEnd);
        } else {
            this.errorMsg = ErrorMessages.LockScreen_ExitCode;
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/lock-screen/lock-screen.component.ts